module.exports = __webpack_public_path__ + "static/img/alaprajzok2.a6c749a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alaprajzok2.jpg
// module id = 528
// module chunks = 2